export const NAVBAR_HEIGHT_PX = 68;

export const ACADEMIC_UPGRADE_RIBBON_HEIGHT_PX = 40;

export const LAYOUT_HEADER_OFFSET_CSS_VAR = '--layout-header-offset';
